














export default

	props:

		step: Number

	computed:

		id: -> "step-wrapper-#{@step}"

		currentStep: -> @$store.state.globals.currentStep

		shown: -> @currentStep >= @step

		classes: -> [
			if @step == 0 then 'first-step'
			if @step == @currentStep then 'current-step'
		]

	mounted: -> @observerSetup()

	beforeDestroy: -> @observerCleanup()

	methods:

		observerSetup: -> @$defer =>
			return unless el = @$refs.wrapper

			# Detect when we enter the small sliver in the bottom 10% of the viewport
			@observer = new IntersectionObserver @onObserved,
				rootMargin: '-90% 0px -9% 0px'
				threshold: 0.0

			@observer.observe el

		observerCleanup: -> @observer?.disconnect()

		# When we scroll into view, set 'globals.stepInViewport' to our index
		onObserved: (entries) ->
			return unless entries?[0]?.isIntersecting
			@$store.commit('globals/setStepInViewport', @step)

	watch: shown: -> if @shown then @observerSetup() else @observerCleanup()



